"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styles = require("./SectionWithFooter.less");
const SectionWithFooter = ({ children, footer }) => (React.createElement("div", { className: 'vf-border-gray-light-color', style: { borderRadius: '2px' } },
    React.createElement("div", { style: { padding: '2rem' } }, children),
    React.createElement("div", { className: styles.footer, style: { padding: '2rem' } }, footer)));
exports.default = SectionWithFooter;
